import {useCallback, useEffect, useReducer} from "react";
import {GptContextDispatchMessageType} from "./GptContext.interfaces";
import {initialState, reducer} from "./GptContext.reducer";
import {ITeamsContext} from "../TeamsContext/TeamsContext.interfaces";
import GptApi from "apis/gptApi";

export const useGptContext = (teamsContext: ITeamsContext) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(function onMount() {
        if (!teamsContext.loaded) return;
        (fetchAllGpts)();
    }, [teamsContext.loaded]);

    const fetchAllGpts = useCallback(async () => {
        const gpts = await GptApi.getAllGpt();
        dispatch([
            {type: GptContextDispatchMessageType.SetList, list: gpts},
            {type: GptContextDispatchMessageType.SetLoaded, value: true}
        ]);
    }, []);

    return {
        ...state,
    }
}